
import AppBrowse from "@/components/browse/Browse.vue";
import {Contact, Sale} from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import AppImportCsvModal from "../../components/contacts/ImportCsvModal.vue";
import { CustomerService } from "../../services/customer-service";
import { UserConfigService } from "../../services/user-config-service";
import AppPortalSendModal from "@/components/client-portal/PortalSendModal.vue";
import AppMissingModuleModal from "@/components/common/MissingModuleModal.vue";
import { ISelectItem } from "winfakt-vue-components";
import AppSaleSearchBrowse from "@/components/sales/SaleSearchBrowse.vue";
import AppSaleDetailBrowse from "@/components/sales/SaleDetailBrowse.vue";
import AppBankSearchBrowse from "@/components/bank/BankSearchBrowse.vue";
import { TranslateResult } from "vue-i18n";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { BrowseState } from "@/utils/browse/browse-state";
import {DossierConfigService, AuthService} from "@/services";
import {ContactService} from "@/utils/services/contact-service";
import {getContactServiceByGroupId} from "@/utils/services/contact-services";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import AppExcelMapper from "@/components/contacts/ExcelMapperWrapper.vue";
import { MODULE } from "@/config/modules";


export default Vue.extend({
	data() {
		return {
			uploadCSVModal: false,
			extraFieldsModal: false,
			clientPortalUrl: "",
			selectedItems: [] as Contact[],
			historyOfClientBrowse: "" as "" | "sales" | "sale-rows" | "bank",
			browseState: null as null | BrowseState,
			sendMessageDialogContact: null as null | Contact,
			selectedSale: null as null | Sale,
			excelMapperOpen: false
		};
	},
	props: {
		browseId: Number,
		controlsDisabled: Boolean,
		searchEnabled: Boolean,
		isSearchOnly: Boolean
	},
	computed: {
		baseRoutePath():string{
			return "/contacts/customers";
		},
		dataSource(): IBrowseDataSource<Contact> {
			let elem = this;
			return {
				getFullElement: (el:Contact)=>CustomerService.getContact(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return CustomerService.getTotals(view);
				},
				getElements: CustomerService.getContacts.bind(CustomerService),
				edit(contact: Contact) {
					elem.$router.push(`${elem.baseRoutePath}/edit/${contact.ID}`);
				},
				async delete(contacts: Contact[]) {
					let result = await CustomerService.delContacts(contacts);
					if (!result) {
						await elem.$wf.dialog(elem.$ct("error-cannot-delete"), elem.$t("common.back"), elem.$t("common.attention"), "warning");
						return false;
					}
					return true;
				},
				addRoute: `${elem.baseRoutePath}/new`,
				info(contact: Contact) {
					elem.$router.push(CustomerService.getInfoRoute(contact.ID));
				},
				browseName: "Clients",
				modelName: "Contact",
				browsePermissions: () => UserConfigService.getPermissionSettings().ClientPermissions,
				extraFieldSettings: {
					getExtraFields: CustomerService.getExtraFields.bind(CustomerService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().ClientNames,
					batchEdit: CustomerService.batchEditExtraField.bind(CustomerService),
					edit: (CustomerService.updateExtraFields as any).bind(CustomerService)
				}
			};
		},
		canWrite(): boolean {
			return UserConfigService.hasCurrentUserPermission((p) => p.ClientPermissions.hasWritePermissions());
		},
		canCreateClientPortal(): boolean {
			return true;
			//return AuthService.hasModule(83);
		},
		// eslint-disable-next-line
		buttonBarItems():ISelectItem<string | Function>[]{
			let result = [] as ISelectItem<string | Function>[];
			if (this.canWrite){
				result.push({
						text: this.$ct("tooltip.import-csv").toString(),
						value: "open-import-csv-modal",
						icon: "upload",
						disabled: !AuthService.hasModule(MODULE.IMPORT)
					},
					{
						text: this.$ct("excel-conversion"),
						value: ()=>this.excelMapperOpen = true,
						icon: "file-excel",
						disabled: !AuthService.hasModule(MODULE.IMPORT)
					});
			}
			let has1ItemSelected = this.selectedItems.length == 1;
			result.push(
				{
					text: this.$ct("tooltip.open-client-portal-url").toString(),
					value: "open-client-portal",
					icon: "globe",
					disabled: !has1ItemSelected
				},
				{
					text: this.$ct("tooltip.send-client-portal-url").toString(),
					value: "open-client-portal-modal",
					icon: "link",
					disabled: !has1ItemSelected
				},
				{
					text: this.$ct("history-of-this-client-in-sales").toString(),
					value: "open-history-of-client-in-sales",
					icon: "file-invoice",
					disabled: !has1ItemSelected || !UserConfigService.hasCurrentUserPermission(perm=>perm.SalePermissions.CanRead)
				},
				{
					text: this.$ct("history-of-this-client-in-sale-detail").toString(),
					value: "open-history-of-client-in-sale-detail",
					icon: "th-list",
					disabled: !has1ItemSelected || !UserConfigService.hasCurrentUserPermission(perm=>perm.SaleRowPermissions.CanRead)
				},
				{
					text: this.$ct("history-of-this-client-in-bank").toString(),
					value: "open-history-of-client-in-bank",
					icon: "piggy-bank",
					disabled: !has1ItemSelected || !UserConfigService.hasCurrentUserPermission(perm=>perm.BankPermissions.CanRead)
				},				{
					text: this.$ct("create-new-document").toString(),
					value: "new-document",
					icon: "plus",
					disabled: !has1ItemSelected || !UserConfigService.hasCurrentUserPermission(perm=>perm.SalePermissions.CanRead)
				}
			);

			if (AuthService.isDevModeEnabled){
				result.push({
					text: "Contacten opnieuw opslaan",
					value: this.resaveContacts,
					icon: "save"
				});
			}

			return result;
		},
		selectedContact():Contact | null {
			if (this.selectedItems.length != 1){
				return null;
			}
			return this.selectedItems[0];
		},
		historyOfClientTitle():TranslateResult{
			if (this.historyOfClientBrowse == "sales") {
				return this.$ct("history-of-this-client-in-sales");
			}
			if (this.historyOfClientBrowse == "sale-rows"){
				return this.$ct("history-of-this-client-in-sale-detail");
			}
			if (this.historyOfClientBrowse == "bank"){
				return this.$ct("history-of-this-client-in-bank");
			}
			return "";
		},
		contactService():ContactService{
			return getContactServiceByGroupId(1);
		},
	},
	watch: {
		selectedItems(){
			this.contactService.selectedContacts = this.selectedItems;
		},
		"$route.path": {
			immediate: true,
			deep: true,
			handler(){
				if (this.$route.path.split("/").length == 3){
					ToolbarService.title = this.$ct("titles.clients");
				}
			}
		}
	},
	methods: {
		onSelectionChange(sales:Sale[]){
			if(!sales.length)
				return;
			this.selectedSale = sales[0];
		},
		openDocument(){
			if(!this.selectedSale)
				return;
			let s = this.selectedSale.ID;
			window.open(`/sales/info/${s}`, "_blank");
		},
		onSearchItemSelected(contact: Contact) {
			this.$emit("search-item-selected", contact);
		},
		async openClientPortalModal() {
			this.clientPortalUrl = await CustomerService.getClientPortalUrl(this.selectedItems[0].ID);
		},
		async openClientPortal() {
			let u = await CustomerService.getClientPortalUrl(this.selectedItems[0].ID);
			window.open(u, "_blank");
		},
		openImportCsvModal(){
			this.uploadCSVModal = true;
		},
		openHistoryOfClientSales(){
			this.historyOfClientBrowse = "sales";
		},
		openHistoryOfClientSaleDetail(){
			this.historyOfClientBrowse = "sale-rows";
		},
		openHistoryOfClientBank(){
			this.historyOfClientBrowse = "bank";
		},
		newDocument(){
			this.$router.push(`/sales/new?typeId=1&contactId=`+this.selectedItems[0].ID);
		},
		async updateView(){
			if (!this.browseState) return;
			await this.browseState.fetch();
		},
		async resaveContacts(){
			await CustomerService.resaveContacts(this.selectedItems.map(c=>c.ID));
			this.$wf.notify("Contacten opnieuw opslaan is gestart", "info", 3000, "info-circle");
		},
		onColClick(result:string, value:Contact){
			if (result == "send-mail") {
				this.sendMessageDialogContact = value;
			}
		},
		closeSendMessageDialog(){
			this.sendMessageDialogContact = null;
		}
	},
	components: {
		AppBrowse,
		AppImportCsvModal,
		AppPortalSendModal,
		AppMissingModuleModal,
		AppSaleSearchBrowse,
		AppSaleDetailBrowse,
		AppBankSearchBrowse,
		AppSendMessageDialog,
		AppExcelMapper
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	},
});
